<template>
  <div class="faultInfoContent">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="info">
        <template #title>
          <span>
            <img src="../../assets/svg/faultIcon.svg" alt="" />
            故障信息
          </span>
        </template>
        <el-form :model="form" :rules="formRules" ref="faultForm">
          <el-descriptions :column="3" border>
            <el-descriptions-item
              label="故障发生日期"
              :labelClassName="this.authStatus ? '' : 'lable-required'"
              :contentClassName="this.authStatus ? '' : 'content-input'"
            >
              <el-form-item prop="happenDate" v-if="!authStatus">
                <el-date-picker
                  :clearable="false"
                  :disabled="authStatus"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  v-model="form.happenDate"
                  @blur="inputBlur(form.happenDate, 'happenDate')"
                ></el-date-picker>
              </el-form-item>
              <span v-else>
                {{ form.happenDate }}
              </span>
            </el-descriptions-item>
            <el-descriptions-item
              label="故障发生地点"
              :contentClassName="this.authStatus ? '' : 'content-input'"
            >
              <el-form-item prop="happenPlace" v-if="!authStatus">
                <el-input
                  :disabled="authStatus"
                  maxlength="200"
                  placeholder="请输入"
                  v-model="form.happenPlace"
                  @blur="inputBlur(form.happenPlace, 'happenPlace')"
                ></el-input>
              </el-form-item>
              <span v-else>{{ form.happenPlace }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="报修日期">{{
              form.repairDate
            }}</el-descriptions-item>
            <el-descriptions-item label="严重程度" v-bind="authStatus && editStatus ? '' : otherClassName">
              <div v-if="authStatus && editStatus">
                <div v-for="(item, index) in severityData" :key="index">
                  <span v-if="item.code == form.severityLevel">
                    {{ item.label}}
                  </span>
                </div>
              </div>
              <div v-else>
                <el-form-item prop="severityLevel">
                  <el-select
                    filterable
                    clearable
                    v-model="form.severityLevel"
                    :disabled="authStatus && editStatus"
                    @blur="inputBlur(form.severityLevel, 'severityLevel')"
                  >
                    <el-option
                      v-for="(item, index) in severityData"
                      :key="index"
                      :label="item.label"
                      :value="item.code"
                    >
                      <el-tooltip placement="right" effect="light">
                        <div
                          slot="content"
                          class="severityTips"
                          v-html="item.desc"
                        ></div>
                        <span>{{ item.label }}</span>
                      </el-tooltip>
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-descriptions-item>
            <!-- <el-descriptions-item label="维修方案"  v-bind="baseClassConfig">
            <el-select filterable clearable v-model="form.repairPlan" placeholder="请选择" @blur="inputBlur(form.repairPlan, 'repairPlan')" :disabled="authStatus">
              <el-option label="维修" :value="0" />
              <el-option label="更换" :value="1" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="故障类别"  v-bind="baseClassConfig">
            <el-select filterable clearable v-model="form.faultType" @blur="inputBlur(form.faultType, 'faultType')" placeholder="请选择" :disabled="authStatus">
              <el-option v-for="item in badTypeList" :key="item.code" :label="item.value"
                :value="Number(item.code)">
              </el-option>
            </el-select>
          </el-descriptions-item> -->
            <el-descriptions-item
              label="是否重点问题"
              v-bind="baseClassConfig"
              :content-class-name="
                baseClassConfig.labelClassName == '' ? '' : 'content-input'
              "
            >
              <div v-if="baseClassConfig.labelClassName == 'lable-required'">
                <el-form-item prop="importantType">
                  <el-radio-group
                    v-model="form.importantType"
                    @blur="inputBlur(form.importantType, 'importantType')"
                    :disabled="authStatus"
                  >
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div v-else>{{ form.importantType == 1 ? "是" : "否" }}</div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="3" border v-if="form.importantType === 1">
            <el-descriptions-item :span="6" v-bind="translateClassName">
              <template slot="label">
                <div class="labelDetail">
                  <p>重点问题描述</p>
                  <div>
                    <translate
                      :content="form.importantDescribe"
                      field="importantDescribeCh"
                      @getTranslateVal="
                        (field, value) => {
                          this.$set(form, field, value);
                        }
                      "
                    />
                  </div>
                </div>
              </template>
              <div class="translateDetail">
                <el-form-item prop="importantDescribe" v-if="!authStatus">
                  <el-input
                    @blur="
                      inputBlur(form.importantDescribe, 'importantDescribe')
                    "
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    v-model="form.importantDescribe"
                    :disabled="authStatus"
                    type="textarea"
                    placeholder="请输入重点问题描述"
                  />
                </el-form-item>
                <div v-else class="leftForm problemDesInfo">{{ form.importantDescribe }}</div>
                <div class="problemDesInfo">{{ form.importantDescribeCh }}</div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="3" border v-bind="serviceClassName">
            <el-descriptions-item
              label="是否有维修措施"
              v-bind="serviceClassName"
            >
              <div v-if="baseClassConfig.labelClassName == 'lable-required'">
                <el-form-item prop="serviceMeasure">
                  <el-radio-group
                    v-model="form.serviceMeasure"
                    @blur="inputBlur(form.serviceMeasure, 'serviceMeasure')"
                    :disabled="authStatus"
                  >
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
              <div v-else>{{ form.serviceMeasure == 1 ? "是" : "否" }}</div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="3" border v-if="form.serviceMeasure == 1">
            <el-descriptions-item :span="6" v-bind="translateClassName">
              <template slot="label">
                <div class="labelDetail">
                  <p>市场维修措施</p>
                  <div>
                    <translate
                      :content="form.marketService"
                      field="marketServiceCh"
                      @getTranslateVal="
                        (field, value) => {
                          this.$set(form, field, value);
                        }
                      "
                    />
                  </div>
                </div>
              </template>
              <div class="translateDetail">
                <el-form-item prop="marketService"  v-if="!authStatus">
                  <el-input
                    :autosize="{ minRows: 4, maxRows: 4 }"
                    v-model="form.marketService"
                    @blur="inputBlur(form.marketService, 'marketService')"
                    :disabled="authStatus"
                    type="textarea"
                    placeholder="请输入市场维修措施"
                  />
                </el-form-item>
                <div v-else class="leftForm problemDesInfo">{{form.marketService}}</div>
                <div class="problemDesInfo">{{form.marketServiceCh}}</div>
              </div>
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions :column="3" border>
            <el-descriptions-item
              label="零部件类别"
              v-bind="componentCategoryClassName"
            >
              <el-form-item
                v-if="canEditComponentCategory"
                prop="componentCategory"
              >
                <el-select
                  filterable
                  clearable
                  v-model="form.componentCategory"
                  @change="
                    inputBlur(form.componentCategory, 'componentCategory')
                  "
                >
                  <el-option
                    v-for="(item, index) in componentCategoryList"
                    :key="index"
                    :label="item[componentCategoryName.get('zh')]"
                    :value="Number(item.code)"
                  />
                </el-select>
              </el-form-item>
              <span v-else>{{ componentCategoryLabel }}</span>
            </el-descriptions-item>
            <el-descriptions-item label="零部件批次信息">{{
              form.componentBatchs
            }}</el-descriptions-item>
            <el-descriptions-item label="订单号">{{
              form.orderNum
            }}</el-descriptions-item>
            <el-descriptions-item label="订单数量">
              {{ form.carTotal }}
            </el-descriptions-item>
            <el-descriptions-item label="故障数量" v-bind="authStatus ? '' : baseClassConfig">
              <el-form-item prop="faultNumber" v-if="!authStatus">
                <el-input-number
                  :disabled="authStatus"
                  :controls="false"
                  :precision="0"
                  v-model="form.faultNumber"
                  @blur="inputBlur(form.faultNumber, 'faultNumber')"
                  placeholder="请输入故障数量"
                >
                </el-input-number>
              </el-form-item>
              <div v-else>{{form.faultNumber}}</div>
            </el-descriptions-item>
            <el-descriptions-item
              label="疑似/祸首件代码"
              :contentClassName="authStatus ? '' :'content-input'"
            >
              <div class="searchFlex" v-if="!authStatus">
                <el-form-item prop="suspectPartNumber">
                  <el-input
                    v-model="form.suspectPartNumber"
                    @blur="
                      inputBlur(form.suspectPartNumber, 'suspectPartNumber')
                    "
                    :disabled="authStatus"
                    placeholder="请输入疑似/祸首件代码"
                  ></el-input>
                  <el-button
                    v-if="!authStatus"
                    class="primary-btn"
                    type="primary"
                    @click="handlePartSearch"
                    >查询</el-button
                  >
                </el-form-item>
              </div>
              <div v-else>{{ form.suspectPartNumber }}</div>
            </el-descriptions-item>
            <el-descriptions-item
              label="疑似/祸首件名称"
              :contentClassName="authStatus ? '' : 'content-input'"
            >
              <el-form-item prop="suspectPartName" v-if="!authStatus">
                <el-input
                  v-model="form.suspectPartName"
                  @blur="inputBlur(form.suspectPartName, 'suspectPartName')"
                  :disabled="authStatus"
                  placeholder="请输入疑似/祸首件名称"
                ></el-input>
              </el-form-item>
              <div v-else>
                {{form.suspectPartName}}
              </div>
            </el-descriptions-item>
            <!-- <el-descriptions-item label="供应商代码/名称" :content-class-name="baseClassConfig.contentClassName">
            <el-input v-model="form.supplierInfo" @blur="inputBlur(form.supplierInfo,'supplierInfo')" :disabled="authStatus" placeholder="请输入供应商代码/名称"></el-input>
          </el-descriptions-item> -->
          </el-descriptions>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import Translate from "@/components/translate";
import componentConfig from "@/mixins/componentConfig";
import { getCheckPart } from "@/util/qualityUtil/checkPart";
import { getCurrentRoles } from "@/utils/role";
export default {
  name: "faultInfo",
  components: { Translate },
  mixins: [componentConfig],
  data() {
    return {
      activeNames: ["info"], // 全部展开
      // badTypeList: { 0: [], 1: [] }, // 故障类型列表 0-燃油车,1-电动车
      form: {},
      editStatus: true,
    };
  },
  props: {
    faultList: {
      type: [Array, Object],
      //   default:() => []
    },
    // true 不可编辑 false 可编辑
    authStatus: {
      type: Boolean,
    },
  },
  computed: {
    // 是否显示必填*
    baseClassConfig() {
      return {
        labelClassName: this.authStatus ? "" : "lable-required",
        contentClassName: "content-input",
      };
    },
    // 严重程度必填状态
    otherClassName() {
      return {
        labelClassName:
          this.authStatus && this.editStatus ? "" : "lable-required",
        contentClassName: "content-input",
      };
    },
    canEditComponentCategory() {
      const { userTaskId, taskStatus } = this.faultList || {};
      return (
        !this.authStatus &&
        taskStatus === 0 &&
        userTaskId === "Activity_0wh76h6"
      );
    },
    componentCategoryClassName() {
      return this.canEditComponentCategory
        ? {
            labelClassName: "lable-required",
            contentClassName: "content-input",
          }
        : {};
    },
    componentCategoryLabel() {
      const item = this.componentCategoryList.find(
        (item) => Number(item.code) === Number(this.form.componentCategory)
      );
      return item ? item[this.componentCategoryName.get("zh")] : "";
    },
    // 翻译
    translateClassName() {
      return {
        labelClassName: `translate-label ${this.baseClassConfig.labelClassName}`,
        contentClassName: "translate-content",
      };
    },
    // 维修措施
    serviceClassName() {
      return {
        labelClassName: `${this.baseClassConfig.labelClassName} ${
          this.form.serviceMeasure == 0 ? " bottom-none" : ""
        } ${this.form.importantType == 0 ? " top-none" : ""}`,
        contentClassName: `${
          this.baseClassConfig.labelClassName == "lable-required"
            ? this.baseClassConfig.contentClassName
            : ""
        } ${this.form.serviceMeasure == 0 ? " bottom-none" : ""} ${
          this.form.importantType == 0 ? " top-none" : ""
        }`,
      };
    },
    formRules() {
      const isRequired = !this.authStatus;
      const otherRequired = !(this.authStatus && this.editStatus);
      // 公共规则配置
      const commonRule = {
        required: isRequired,
        trigger: ["change", "blur"],
      };
      // 文件类字段的通用规则
      const createRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}不能为空` },
      ];
      return {
        happenDate: createRule("故障发生日期"),
        severityLevel: [
          {
            required: otherRequired,
            message: "严重程度不能为空",
            trigger: ["change", "blur"],
          },
        ],
        importantType: createRule("是否重点问题"),
        importantDescribe: createRule("重点问题描述"),
        serviceMeasure: createRule("是否有维修措施"),
        marketService: createRule("市场维修措施"),
        componentCategory: [
          {
            required: this.canEditComponentCategory,
            message: "零部件类别不能为空",
            trigger: ["change", "blur"],
          },
        ],
        faultNumber: createRule("故障数量"),
      };
    },
  },
  async created() {
    // this.getBadTypeList();
    this.getTypeList();
    this.getFaultInfo();
    this.getAuditStatus();
  },
  methods: {
    // 技术经理和质量经理
    getAuditStatus() {
      const userRoles = getCurrentRoles();
      const { userTaskId, taskStatus } = this.faultList;
      const rolePermissions = {
        技术经理: ["Activity_0cimoly", "Activity_1ayglqh"],
        质量经理: ["Activity_1jmu1ad"],
      };
      this.editStatus =
        taskStatus !== 0 ||
        !userRoles.some((r) => rolePermissions[r]?.includes(userTaskId));
    },
    // 获取数据
    getFaultInfo() {
      if (this.faultList) {
        this.form = this.faultList;
        if (
          this.form.componentCategory !== "" &&
          this.form.componentCategory != null
        ) {
          this.form.componentCategory = Number(this.form.componentCategory);
        }
      }
    },
    // 监听失去焦点
    inputBlur(val, type) {
      this.form[type] = val;
      this.$emit("update:faultList", this.form);
    },
    // 获取疑似/祸首件名称
    handlePartSearch() {
      getCheckPart(this);
    },
    validateForm() {
      return this.$refs["faultForm"]
        .validate()
        .then(() => ({ isValid: true, object: null }))
        .catch((errors) => ({ isValid: false, object: errors }));
    },
    // 获取故障类别列表
    // async getBadTypeList() {
    //   if(this.form.carAttribute == 0) {
    //     this.badTypeList = await getDictItem("badTypeList0");
    //   } else {
    //     this.badTypeList = await getDictItem("badTypeList1");
    //   }
    // },
  },
};
</script>
